export const imgUrl = 'https://assets.suntec.adsign.adactive.asia';
export const url = import.meta.env.VITE_BASE_URL;
export const editorUrl = import.meta.env.VITE_ADSIGN_EDITOR_URL;

